module.exports = __webpack_public_path__ + "static/11-0214e2abf9984eb6057848c10b6901ff.jpg";